module.exports = __webpack_public_path__ + "img/imgXharra-4.be097e43.png";